var render = function render(){var _vm=this,_c=_vm._self._c;return _c('carousel',{attrs:{"data":_vm.data,"autoplay":true,"interval":3000}})
}
var staticRenderFns = []

export { render, staticRenderFns }